import React, { useEffect, useState } from "react";
//import { useHistory } from "react-router-dom";

import FormSourcesIndicators from "componentes/indicators/formSourcesIndicators";
import FormNotesIndicators from "componentes/indicators/formNotesIndicators";
import ModalSources from "componentes/indicators/modalSources";
import FormTranslations from "componentes/indicators/formTranslations";

import { BtnSeleccionar } from "componentes/templates/btn_crud";
import { Cargando } from "componentes/templates/cargando";

const ModalContainer = ({ modalTitle, info_component , ind_int_id, labelClose, tableT }) => {
  //console.log("pasando por Modalcontaier ");
  const [active, setActive] = useState(false);
  const [content, setContent] = useState(null);
  const [cargando, setCargando] = useState(false);
  //let history = useHistory();

  const toggle = () => {
    //let url2 = `/${info.regresa}/${info.use_int_id}`
    //window.location.reload();
    setActive(!active);
  };

  const gCerrar = () => {
    window.location.reload();
  }

 
  useEffect(() => {
    showContent();
    return () => {
      setCargando(true);
    };
    // eslint-disable-next-line
  }, []);

  const showContent = () => {
    switch (info_component) {
      case "sou":
        setContent(<FormSourcesIndicators ind_int_id={ind_int_id} />);
        break;
      case "not":
        setContent(<FormNotesIndicators ind_int_id={ind_int_id} />);
        break;

        case "formsou":
          setContent(<ModalSources ind_int_id={ind_int_id} />);
          break;

      case "tra":
            setContent(<FormTranslations ind_int_id={ind_int_id} tableT={tableT}/>);
            break;

      default:
        <>Sin contendio, enviar prop del modulo</>;
        break;
    }
  };

  if (cargando) return <Cargando />;
  else
    return (
      <>
        <BtnSeleccionar toggle={toggle}> {modalTitle} </BtnSeleccionar>
        <ModalCard
          active={active}
          title={modalTitle}
          content={content}
          gCerrar={gCerrar}
          toggle={toggle}
          labelClose={labelClose}
        />
      </>
    );
};

const ModalCard = ({ active, title, content, gCerrar, toggle, labelClose}) => (
  <div className={`modal ${active ? "is-active" : ""}`}>
    <div className="modal-background" onClick={toggle} />
    <div className="modal-card">
      <header className="modal-card-head">
        <p className="modal-card-title">{title}</p>
        <button className="delete" aria-label="close" onClick={toggle} />
      </header>
      <section className="modal-card-body">{content}</section>
      <footer className="modal-card-foot">
        <button type="button" className="button is-small is-primary" onClick={toggle}>
        {labelClose}
        </button>
      </footer>
    </div>
  </div>
);

export default ModalContainer;
